import {message} from '@sail/intl';

export const sectionTitle = message({
  id: 'mkt-ssr.startup_partners.footer_cta.section_title',
  defaultMessage: 'Not incorporated yet? We can help.',
  description: 'Title for the CTA footer section',
});

export const sectionBody = message({
  id: 'mkt-ssr.startup_partners.footer_cta.section_body',
  defaultMessage:
    'Stripe Atlas is a powerful, safe, and easy-to-use platform for forming a company. By removing lengthy paperwork, legal complexity, and numerous fees, Stripe Atlas helps you launch your startup from anywhere in the world.',
  description: 'Body text for the CTA footer section',
});

export const sectionCta = message({
  id: 'mkt-ssr.startup_partners.footer_cta.section_cta',
  defaultMessage: 'Learn More',
  description: 'CTA button text for the main section',
});

export const incorporationGuideTitle = message({
  id: 'mkt-ssr.startup_partners.footer_cta.incorporation_guide_title',
  defaultMessage: 'Read our guide on incorporating',
  description: 'Title for the incorporation guide section',
});

export const incorporationGuideBody = message({
  id: 'mkt-ssr.startup_partners.footer_cta.incorporation_guide_body',
  defaultMessage:
    'Learn what it means to turn your business into a company and how to do it.',
  description: 'Body text for the incorporation guide section',
});

export const incorporationGuideCta = message({
  id: 'mkt-ssr.startup_partners.footer_cta.incorporation_guide_cta',
  defaultMessage: 'Read the guide',
  description: 'CTA button text for the incorporation guide section',
});

export const entityTypesTitle = message({
  id: 'mkt-ssr.startup_partners.footer_cta.entity_types_title',
  defaultMessage: 'LLCs vs. C Corps',
  description: 'Title for the entity types section',
});

export const entityTypesBody = message({
  id: 'mkt-ssr.startup_partners.footer_cta.entity_types_body',
  defaultMessage:
    'Read more about the advantages and disadvantages of the most common entity types for incorporating.',
  description: 'Body text for the entity types section',
});

export const entityTypesCta = message({
  id: 'mkt-ssr.startup_partners.footer_cta.entity_types_cta',
  defaultMessage: 'Read the guide',
  description: 'CTA button text for the entity types section',
});
